
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class InlineAlert extends Vue {
    @Prop() errorMessage!: string;
    @Prop({ default: false }) isInvalid!: boolean;
}
